















import Card from "@/components/UI/Card.vue"

export default {
  name: "collapse-card",
  props: ['defaultActiveKey', "title", "customStyle", "lengthenHeight"],
  components: {
    Card
  },
};
